export class CommercetoolsConfig {
    static rentalOnly = false;
}
